import { api } from "@/api";
import { sleep } from "@/shared/utils";

interface CajaAssignResponse {
    id: string,
    nombre: string,
    abierto: boolean,
    token: string,
}

export async function getCajaActual(token: string): Promise<CajaAssignResponse> {
    await sleep(1000);
    const response = await api.get("caja_actual", {
        headers: { "X-Caja-Token": token }
    });

    return { ...response.data, token };
}